import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { defineMessages, useIntl } from 'react-intl';
import AddSuperProfileButton from './AddSuperProfileButton';

const i18nMessages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
  jobTitle: {
    id: 'account.super-profiles.list.header.job-title',
    defaultMessage: 'Job title',
  },
  jobDescription: {
    id: 'account.super-profiles.list.header.job-description',
    defaultMessage: 'Job description',
  },
  jobProfile: {
    id: 'account.super-profiles.list.header.job-profile',
    defaultMessage: 'Job profile',
  },
  assessmentTemplate: {
    id: 'account.super-profiles.list.header.assessment-template',
    defaultMessage: 'Assessment template',
  },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  actions: {
    id: 'attrs.actions',
    defaultMessage: 'Actions',
  },
});

const SuperProfilesListHeader = ({ filter, setFilter }) => {
  const { formatMessage } = useIntl();

  const updateFilter = (event) => {
    const value = event.currentTarget.value;

    setFilter(value);
  };

  return (
    <>
      <div className="p-grid">
        <div className="p-col">
          <div className="p-inputgroup">
            <InputText
              value={filter}
              onChange={updateFilter}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  updateFilter(event);
                }
              }}
            />
            <Button icon="pi pi-search" onClick={updateFilter} />
          </div>
        </div>
        <div className="p-col align-right">
          <AddSuperProfileButton />
        </div>
      </div>
      <br />
      <div className="font-weight-600 flex-space-between margin-bottom-1">
        <div>{formatMessage(i18nMessages.name)}</div>
        <div>{formatMessage(i18nMessages.created)}</div>
        <div>{formatMessage(i18nMessages.updated)}</div>
        <div>{formatMessage(i18nMessages.jobTitle)}</div>
        <div>{formatMessage(i18nMessages.jobDescription)}</div>
        <div>{formatMessage(i18nMessages.jobProfile)}</div>
        <div>{formatMessage(i18nMessages.assessmentTemplate)}</div>
        <div>{formatMessage(i18nMessages.status)}</div>
        <div>{formatMessage(i18nMessages.actions)}</div>
      </div>
    </>
  );
};

export default SuperProfilesListHeader;
